import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

// Action Creators
export const getDeliveryBoysRequest = () => ({ type: 'GET_DELIVERY_BOYS_REQUEST' })
export const getDeliveryBoysSuccess = (data) => ({ type: 'GET_DELIVERY_BOYS_SUCCESS', data })
export const getDeliveryBoysFailure = (error) => ({ type: 'GET_DELIVERY_BOYS_FAILURE', error })

export const getSingleDeliveryBoyRequest = () => ({ type: 'GET_SINGLE_DELIVERY_BOY_REQUEST' })
export const getSingleDeliveryBoySuccess = (data) => ({
  type: 'GET_SINGLE_DELIVERY_BOY_SUCCESS',
  data,
})
export const getSingleDeliveryBoyFailure = (error) => ({
  type: 'GET_SINGLE_DELIVERY_BOY_FAILURE',
  error,
})

export const addDeliveryBoyRequest = () => ({ type: 'ADD_DELIVERY_BOY_REQUEST' })
export const addDeliveryBoySuccess = () => ({ type: 'ADD_DELIVERY_BOY_SUCCESS' })
export const addDeliveryBoyFailure = (error) => ({ type: 'ADD_DELIVERY_BOY_FAILURE', error })

export const updateDeliveryBoyRequest = () => ({ type: 'UPDATE_DELIVERY_BOY_REQUEST' })
export const updateDeliveryBoySuccess = () => ({ type: 'UPDATE_DELIVERY_BOY_SUCCESS' })
export const updateDeliveryBoyFailure = (error) => ({ type: 'UPDATE_DELIVERY_BOY_FAILURE', error })

export const deleteDeliveryBoyRequest = () => ({ type: 'DELETE_DELIVERY_BOY_REQUEST' })
export const deleteDeliveryBoySuccess = () => ({ type: 'DELETE_DELIVERY_BOY_SUCCESS' })
export const deleteDeliveryBoyFailure = (error) => ({ type: 'DELETE_DELIVERY_BOY_FAILURE', error })

export const getAssignedOrdersRequest = () => ({ type: 'GET_ASSIGNED_ORDERS_REQUEST' })
export const getAssignedOrdersSuccess = (data) => ({ type: 'GET_ASSIGNED_ORDERS_SUCCESS', data })
export const getAssignedOrdersFailure = (error) => ({ type: 'GET_ASSIGNED_ORDERS_FAILURE', error })

// Thunk Actions

export const getDeliveryBoys = () => {
  return (dispatch) => {
    dispatch(getDeliveryBoysRequest())

    fetch(URL.BASE_URL + URL.END_POINT.deliveryboys, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        return res.json()
      })
      .then((data) => dispatch(getDeliveryBoysSuccess(data)))
      .catch((err) => {
        dispatch(getDeliveryBoysFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const getSingleDeliveryBoy = (id) => {
  return (dispatch) => {
    dispatch(getSingleDeliveryBoyRequest())

    fetch(`${URL.BASE_URL + URL.END_POINT.deliveryboys}${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        return res.json()
      })
      .then((data) => dispatch(getSingleDeliveryBoySuccess(data)))
      .catch((err) => {
        dispatch(getSingleDeliveryBoyFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const addDeliveryBoy = (formData) => {
  return async (dispatch) => {
    dispatch(addDeliveryBoyRequest())

    fetch(`${URL.BASE_URL + URL.END_POINT.deliveryboys}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(formData),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        dispatch(addDeliveryBoySuccess())
        toast('Delivery boy added successfully', { type: 'success' })
        dispatch(getDeliveryBoys())
      })
      .catch((err) => {
        dispatch(addDeliveryBoyFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const updateDeliveryBoy = (id, formData) => {
  return async (dispatch) => {
    dispatch(updateDeliveryBoyRequest())

    fetch(`${URL.BASE_URL + URL.END_POINT.deliveryboys}${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(formData),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        dispatch(updateDeliveryBoySuccess())
        toast('Delivery boy updated successfully', { type: 'success' })
        dispatch(getDeliveryBoys())
      })
      .catch((err) => {
        dispatch(updateDeliveryBoyFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const deleteDeliveryBoy = (id) => {
  return (dispatch) => {
    dispatch(deleteDeliveryBoyRequest())

    fetch(`${URL.BASE_URL + URL.END_POINT.deliveryboys + id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        dispatch(deleteDeliveryBoySuccess())
        toast('Delivery boy deleted successfully', { type: 'success' })
        dispatch(getDeliveryBoys())
      })
      .catch((err) => {
        dispatch(deleteDeliveryBoyFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const getAssignedOrders = () => {
  return async (dispatch) => {
    dispatch(getAssignedOrdersRequest())

    fetch(`${URL.BASE_URL + URL.END_POINT.assignorder}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        return res.json()
      })
      .then((data) => dispatch(getAssignedOrdersSuccess(data.data)))
      .catch((err) => {
        dispatch(getAssignedOrdersFailure(err.message))
        toast(err.message, { type: 'error' })
      })
  }
}

export const assignOrderToDeliveryBoy = (payload) => {
  return (dispatch) => {
    dispatch({ type: 'ASSIGN_ORDER_REQUEST' })

    fetch(`${URL.BASE_URL + URL.END_POINT.assignorder}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.json().then((r) => r.message))
        return res.json()
      })
      .then((data) => {
        dispatch({ type: 'ASSIGN_ORDER_SUCCESS', payload: data })
        toast('Order assigned successfully', { type: 'success' })
      })
      .catch((err) => {
        dispatch({ type: 'ASSIGN_ORDER_FAILURE', payload: err.message })
        toast(err.message, { type: 'error' })
      })
  }
}

const initialDeliveryBoysState = {
  deliveryBoys: [],
  assignedOrders: [],
  loading: false,
  loadingAssigned: false,
  error: null,
  errorAssigned: null,
  singleDeliveryBoy: null,
  loadingSingle: false,
  errorSingle: null,
}

export const deliveryBoysReducer = (state = initialDeliveryBoysState, action) => {
  switch (action.type) {
    case 'GET_DELIVERY_BOYS_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_DELIVERY_BOYS_SUCCESS':
      return { ...state, deliveryBoys: action.data.data, loading: false }
    case 'GET_DELIVERY_BOYS_FAILURE':
      return { ...state, loading: false, error: action.error }

    case 'GET_SINGLE_DELIVERY_BOY_REQUEST':
      return { ...state, loadingSingle: true, errorSingle: null }
    case 'GET_SINGLE_DELIVERY_BOY_SUCCESS':
      return { ...state, singleDeliveryBoy: action.deliveryBoy, loadingSingle: false }
    case 'GET_SINGLE_DELIVERY_BOY_FAILURE':
      return { ...state, loadingSingle: false, errorSingle: action.error }

    case 'GET_ASSIGNED_ORDERS_REQUEST':
      return { ...state, loadingAssigned: true, errorAssigned: null }
    case 'GET_ASSIGNED_ORDERS_SUCCESS':
      return { ...state, loadingAssigned: false, assignedOrders: action.data }
    case 'GET_ASSIGNED_ORDERS_FAILURE':
      return { ...state, loadingAssigned: false, errorAssigned: action.error }

    case 'ADD_DELIVERY_BOY_REQUEST':
    case 'UPDATE_DELIVERY_BOY_REQUEST':
    case 'DELETE_DELIVERY_BOY_REQUEST':
      return { ...state, loading: true }

    case 'ADD_DELIVERY_BOY_SUCCESS':
    case 'UPDATE_DELIVERY_BOY_SUCCESS':
    case 'DELETE_DELIVERY_BOY_SUCCESS':
      return { ...state, loading: false }

    case 'ADD_DELIVERY_BOY_FAILURE':
    case 'UPDATE_DELIVERY_BOY_FAILURE':
    case 'DELETE_DELIVERY_BOY_FAILURE':
      return { ...state, loading: false, error: action.error }

    default:
      return state
  }
}
